export const AUTH_ACTIONS = {
  MANUALLY_SET_TOKEN: 'PM/MANUALLY_SET_TOKEN',
  INIT_AUTHENTICATED_STATUS: 'INIT_AUTHENTICATED_STATUS',
}

export const initAuthenticatedStatus = authenticated => ({
  type: AUTH_ACTIONS.INIT_AUTHENTICATED_STATUS,
  payload: { authenticated },
})
